import { Set } from 'immutable';

export default class BranchHierarchy {

  constructor(hierarchyTerms, hierarchy) {
    this.hierarchyTerms = hierarchyTerms;
    this.hierarchy = hierarchy;
  }

  _isEmpty = (e) => {
    return !e || e.isEmpty();
  };

  _hasNoHierarchy = () => {
    return this._isEmpty(this.hierarchy) || this._isEmpty(this.hierarchyTerms);
  };

  selectOptions = (currentlySelected, tierIndex) => {
    return this._elementsForTier(currentlySelected, tierIndex, tierIndex, (tier, selections) => {
      const selectedIds = selections.map(s => objectId2String(s));
      return tier.filterNot(e => selectedIds.includes(objectId2String(e)));
    });
  };

  _findById = (targetId, tier, tierIndex) => {
    let result = null;
    if (this._isEmpty(tier)) {
      return result;
    }
    tier.forEach((elem) => {
      const elemId = objectId2String(elem);
      const foundMatch = elemId !== null && elemId === objectId2String(targetId);
      if (foundMatch) {
        result = elem;
        return false;
      } else if (elem.has('elements')) {
        const foundChild = this._findById(targetId, elem.get('elements'), tierIndex + 1);
        if (foundChild) {
          result = foundChild;
          return false;
        }
      }
    });
    return result;
  };

  findById = (id) => {
    return this._findById(id, this.hierarchy, 0);
  };

  filtered = (currentlySelected, tierIndex) => this._elementsForTier(currentlySelected, tierIndex, tierIndex);

  filteredBranches = (currentlySelected) => this.filtered(currentlySelected, this.hierarchyTerms.size - 1);

  filteredBranchHierarchy = (currentlySelected) => this._filteredBranchHierarchy(currentlySelected, this.hierarchy, 0);

  _elementsForTier = (currentlySelected, tierIndex, originalTierIndex, handleTier) => {
    if (this._hasNoHierarchy()) {
      return null;
    }
    const rawSelections = currentlySelected.toIndexedSeq().get(tierIndex);
    const selections = rawSelections || Set();
    const selectedIds = selections.map(s => objectId2String(s));
    let tier = this.hierarchy;
    if (tierIndex > 0) {
      const elementsForParentTier = this._elementsForTier(currentlySelected, tierIndex - 1, originalTierIndex, handleTier);
      tier = elementsForParentTier.flatMap((e) => e.get('elements'));
    }
    let result = tier;
    if (handleTier && tierIndex === originalTierIndex) {
      result = handleTier(tier, selections);
    } else if (!selections.isEmpty()) {
      result = tier.filter(e => selectedIds.includes(objectId2String(e)));
    }
    return result;
  };

  _filteredBranchHierarchy = (currentlySelected, tier, tierIndex) => {
    if (this._isEmpty(tier)) {
      return null;
    }
    const rawSelections = currentlySelected.toIndexedSeq().get(tierIndex);
    const selections = rawSelections || Set();
    const selectedIds = selections.map(s => objectId2String(s));
    let filteredTier = tier;
    if (!selections.isEmpty()) {
      filteredTier = tier.filter(e => selectedIds.includes(objectId2String(e)));
    }
    return filteredTier
      .map((e) => {
        if (e.has('elements')) {
          return e.update(
            'elements',
            (elems) => this._filteredBranchHierarchy(currentlySelected, elems, tierIndex + 1)
          );
        }
        return e;
      })
      .filter((e) => {
        const ee = e.get('elements');
        return ee ? !ee.isEmpty() : true;
      });
  };

}

function objectId2String(s) {
  const id = s.get ? s.get('id') : s.id ? s.id : s;
  if (typeof id === 'string') {
    return id;
  } else if (typeof id === 'object' && typeof id.toHexString === 'function') {
    return id.toHexString();
  } else if (id) {
    return id.toString();
  }
  return id;
}



// WEBPACK FOOTER //
// ./src/model/BranchHierarchy.js